export default __webpack_public_path__ + "static/media/ticket-perforated-fill.a1a580f7.svg";